module.exports = __webpack_public_path__ + "assets/img/cus15.caa93145.jpg";